var map = {
	"./pay_icon0.png": "Cwmx",
	"./pay_icon1.png": "mgiQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/P8n";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/order ^\.\/pay_icon.*\.png$
// module id = /P8n
// module chunks = 1